<script>
import axios from 'axios';
import { addPetition, addSignatureToPetition } from '../api/petitions';

export default {
    name : 'CpPetitionSign',
    components: {
        CpButton: require('../button').default,
        CpDialog: require('../dialog').default,
        CpBoxContent: require('../box-content').default,
        CpBox: require('../box').default,
    },
    props : {
        petition_id: Number,
        user:{
            first_name:String,
            last_name:String,
            email:String,
            zip:String
        },
        loggedin:Boolean,
        handleDialog: Function,
        modalFeed: { type: Boolean, default: false },
        setPetitionSigned: Function,
    },
    data() {
        return{
            formErrors:{},
            formSuccess:{},
            disableInput: false,
            newSign : {
                'first_name':this.user.first_name,
                'last_name':this.user.last_name,
                'email':this.user.email,
                'zip':this.user.zip,
                'phone':'',
                'organization':'',
                'keep_anonymous':false,
                'email_me':true,
                'stay_updated':true
            },
            loading: false,
        }
    },
    methods : {
        createSign: function(petition_id){
            this.loading = true;
            addSignatureToPetition( this.petition_id, this.newSign )
                .then((response) => {
                    this.loading = false;
                    this.newSign.first_name = this.user.first_name;
                    this.newSign.last_name = this.user.last_name;
                    this.newSign.email = this.user.email;
                    this.newSign.zip = this.user.zip;
                    this.newSign.phone = '';
                    this.newSign.organization = '';
                    this.newSign.keep_anonymous = false;
                    this.newSign.email_me = true;
                    this.newSign.stay_updated = true;
                    this.formSuccess['message'] = "Thank you for signing the petition.";
                    if (!this.loggedin && this.modalFeed) {
                        this.$emit('postButtonClicked', '');
                    }
                    if (this.setPetitionSigned) {
                        this.setPetitionSigned();
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    this.formErrors['message'] = error.response.data.messages;
                    this.$forceUpdate();
                });
        }
    },
    computed: {
        isAnonymous(){
            return this.newSign.keep_anonymous;
        },
    }
}
</script>

<template>
    <cp-dialog>
        <cp-box>
            <cp-box-content>
                <section class="box-dialog">
                    <svg
                        @click.prevent="handleDialog()"
                        class="close-svg-icon"
                        stroke="currentColor"
                        fill="currentColor"
                        stroke-width="0"
                        viewBox="0 0 512 512"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
                        ></path>
                    </svg>
                    <div style="margin: 15px; text-align: center;">
                        <img style="width: 80px;" src="https://res.cloudinary.com/crowdpac/image/upload/v1584887816/assets/icons/noun_signature_2349935_1.svg">
                        <h2 class="title-sign">Sign Petition</h2>
                    </div>
                    <div v-if="formSuccess['message']" class="text-success heading-2 center" style="margin:15px 0; color: #468847;" >
                        {{ formSuccess['message'] }}
                    </div>
                    <div v-else>
                        <div v-if="formErrors['message']">
                            <div v-for="message in formErrors['message']" class="text-error heading-4 center" style="margin:15px 0; text-align: center;">
                                {{ message }}
                            </div>
                        </div>
                        <form method="POST" enctype="multipart/form-data" v-on:submit.prevent="createSign(petition_id)">
                            <div style="text-align: center;">
                                <div class="mb-input" v-if='!isAnonymous'>
                                    <div class="controls">
                                        <input class="input-sign" type="text" name="first_name" placeholder="First name *"  v-model="newSign.first_name" :disabled="this.loggedin" :required="!isAnonymous"/>
                                    </div>
                                </div>
                                <div class="mb-input" v-if="!isAnonymous">
                                    <div class="controls">
                                        <input class="input-sign" type="text" name="last_name" placeholder="Last name *" v-model="newSign.last_name" :required="!isAnonymous"/>
                                    </div>
                                </div>

                                <div class="mb-input">
                                     <div class="controls">
                                        <input class="input-sign" type="email" name="email" placeholder="Email *" required v-model="newSign.email" :disabled="this.loggedin"/>
                                    </div>
                                </div>

                                <div class="mb-input">
                                    <div class="controls">
                                        <input class="input-sign" type="text" name="zip" placeholder="ZIP code *" required v-model="newSign.zip" />
                                    </div>
                                </div>

                                <div class="mb-input">
                                    <div class="controls">
                                        <input class="input-sign" type="text" name="phone" placeholder="Phone number" v-model="newSign.phone" />
                                    </div>
                                </div>

                                <div class="mb-input">
                                    <div class="controls">
                                        <input class="input-sign" type="text" name="organization" placeholder="Organization" v-model="newSign.organization" />
                                    </div>
                                </div>
                            </div>
                            <div class="mb-checkbox">
                                <input id="keep_anonymous" name="keep_anonymous" type="checkbox" v-model="newSign.keep_anonymous" >
                                <label for="keep_anonymous" class="label-small">
                                    Keep my name anonymous
                                </label>
                            </div>
                            <div class="mb-checkbox">
                                <input id="email_me" name="email_me" type="checkbox" v-model="newSign.email_me">
                                <label for="email_me" class="label-small">
                                    Email me petition updates
                                </label>
                            </div>
                            <div class="mb-checkbox">
                                <input id="stay_updated" name="stay_updated" type="checkbox" v-model="newSign.stay_updated">
                                <label for="stay_updated" class="label-small">
                                    Yes! Sign me up to receive emails from CrowdBlue with daily news, campaigns, and updates.
                                </label>
                            </div>
                            <div style="display: flex; justify-content: flex-end;">
                                <cp-button @click="handleDialog()" class="btn-sign" block>Cancel</cp-button>
                                <cp-button type="submit" class="btn-sign" block primary :loading="loading" :disabled="loading">Sign</cp-button>
                            </div>
                        </form>
                    </div>
                </section>
            </cp-box-content>
        </cp-box>
    </cp-dialog>
</template>

<style scoped>
.box-dialog {
    margin: 2em;
    max-width: 40ch
}
.btn-sign {
    width: 30%;
    margin: 5px;
}
.label-small {
    color: #787878;
    padding-left: 10px;
}
.mb-checkbox {
    margin-bottom: 10px;
    display: flex;
}
.mb-checkbox input[type="checkbox"] {
    flex-shrink: 0;
}
.mb-input {
    margin-bottom: 20px;
}
.input-sign {
    min-width: 220px;
    min-height: 30px;
    border: 1px solid #ccc;
}
.title-sign {
    font-weight: 300;
    line-height: 1.2;
    font-size: 31.5px;
    margin: 0 0 30px;
    font-family: "rooney-web", georgia, serif;
    color: #787878;
}
@media only screen and (max-width: 767px) {
    .box-dialog {
        margin: 2em 0;
    }
}
</style>
